import React from 'react';
import ContentLoader from 'react-content-loader';

const Loading = () => (
  <ContentLoader
    height={550}
    width={400}
    speed={1}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="110" y="100" rx="0" ry="0" width="180" height="180" />
    <rect x="0" y="333" rx="0" ry="0" width="400" height="38" />
    <rect x="0" y="400" rx="0" ry="0" width="150" height="28" />
    <rect x="0" y="460" rx="0" ry="0" width="290" height="20" />
    <rect x="0" y="490" rx="0" ry="0" width="190" height="20" />
    <rect x="0" y="520" rx="0" ry="0" width="240" height="20" />
  </ContentLoader>
);

export default Loading;
